import { Gender, Title } from "../hooks/useApiClient/ClientProxy.generated";

export const getGenderOrDefault = (title?: Title, defaultGender?: Gender): Gender | undefined => {
  let result = defaultGender;
  if (title !== Title.Dr && title !== Title.Mx) {
    result = title === Title.Mr ? Gender.Male : Gender.Female;
  }
  return result;
};
